import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { Card } from '../ui/Card';

const { FiPlay } = FiIcons;

export const VideoPlaceholder = () => {
  return (
    <div className="mb-8">
      <div className="mb-4">
        <h3 className="text-[10px] font-bold text-brand-muted uppercase tracking-widest mb-2">Walkthrough</h3>
        <h2 className="text-2xl font-serif text-brand-text">Video placeholder</h2>
        <p className="text-sm text-brand-muted">Reserve this space for the demo recording that explains the submission flow.</p>
      </div>
      
      <Card noPadding className="border-dashed border-2 border-brand-border bg-brand-light/30 transition-colors hover:border-brand-accent/50 group cursor-pointer">
        <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform duration-300">
            <SafeIcon icon={FiPlay} className="text-2xl text-brand-text ml-1" />
          </div>
          <h3 className="text-lg font-serif text-brand-text mb-2">Walkthrough video goes here.</h3>
          <p className="text-sm text-brand-muted max-w-md">Replace this placeholder with the recorded walkthrough embed or hosted video before the handoff.</p>
        </div>
      </Card>
    </div>
  );
};